/**
 * @module Polyfills
 */

/**
 * Use the performance.now() method if possible, and if not, use Date.now()
 *
 * @returns {number} Time elapsed since the time origin
 * @memberof Polyfills
 */
function now() {
  if (window.performance) {
    return performance.now();
  }

  return Date.now();
}

export default now;
